"use client";

import { useEffect, useState } from "react";
import styles from "./styles.module.css";
import toast from "react-hot-toast";

import { getDeviceTypes, createBulkOrder } from "../../../services/devices";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";

// COMPONENTS
import Button from "../../button-v1";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogBody,
} from "../../ui/dialog";
import {
  ToggleTabs,
  TogglePanel,
  ToggleTabList,
  ToggleTabPanels,
  ToggleTabTrigger,
} from "../../ui/toggle-tabs";

import OrderIndividual from "./order-individual";
import OrderBulk from "./bulk";

const Order = ({ isOpen, setIsOpen }) => {
  const [addType, setAddType] = useState(2);
  const [devices, setDevices] = useState([]);
  const [email, setEmail] = useState(null);

  const queryClient = useQueryClient();

  const tabs = [
    { id: 1, label: "Order Individual" },
    { id: 2, label: "Order in Bulk" },
  ];

  const bulkOrderMutation = useMutation(
    () => {
      if (devices.length > 0 && email?.to && email?.body && email?.subject) {
        const body = {
          items: devices,
          to_email: email.to,
          body: email.body,
          subject: email.subject,
        };

        return createBulkOrder(body);
      } else {
        toast.error("Please provide all fields.");
      }
    },
    {
      onSuccess: () => {
        toast.success("Order Placed Successfully");
        queryClient.invalidateQueries(["ordered-devices"]);
        setDevices([]);
        setAddType(2);
      },
      onError: (req) => toast.error("Could not place order"),
    }
  );

  const placeOrderHandler = () => {
    if (addType === 3) {
      // Move to confirmation step
      setAddType(4);
    } else if (addType === 4) {
      // Confirm and place order
      bulkOrderMutation.mutate();
    }
  };

  const handleEmail = (emailData) => setEmail(emailData);

  return (
    <Dialog open={isOpen} setOpen={() => setIsOpen(false)}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Order Devices</DialogTitle>
        </DialogHeader>
        <DialogBody>
          {addType === 4 ? (
            <div style={{ padding: 12 }}>
              <h4 style={{ margin: 0, marginBottom: 8 }}>Confirm Order</h4>
              <p style={{ marginTop: 0 }}>
                Are you sure you want to place this order?
              </p>
              {/* <div style={{ fontSize: 14, color: "#555" }}>
                <div>Items: {devices?.length || 0}</div>
                {email?.to && <div>To: {email.to}</div>}
                {email?.subject && <div>Subject: {email.subject}</div>}
              </div> */}
            </div>
          ) : (
            <OrderBulk
              addType={addType}
              setAddType={setAddType}
              devices={devices}
              setDevices={setDevices}
              handleEmail={handleEmail}
            />
          )}
        </DialogBody>
        <DialogFooter>
          <>
            {addType === 3 || addType === 4 ? (
              <Button
                disabled={bulkOrderMutation.isLoading}
                variant="ghost"
                onClick={() => setAddType(addType === 4 ? 3 : 2)}
              >
                Previous
              </Button>
            ) : (
              <Button variant="ghost" onClick={() => setIsOpen(false)}>
                Cancel
              </Button>
            )}

            {addType === 1 ? (
              <Button onClick={placeOrderHandler}>Place Order</Button>
            ) : addType === 2 ? (
              <Button
                disabled={devices.length <= 0}
                onClick={() => setAddType(3)}
              >
                Next
              </Button>
            ) : addType === 3 ? (
              <Button
                onClick={placeOrderHandler}
                disabled={devices.length <= 0}
              >
                Place Order
              </Button>
            ) : (
              <Button
                onClick={placeOrderHandler}
                disabled={bulkOrderMutation.isLoading || devices.length <= 0}
                loading={bulkOrderMutation.isLoading}
              >
                Yes, Place Order
              </Button>
            )}
          </>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default Order;
